<template>
  <a-card>
    <case-detail :case-id="caseId" />
  </a-card>
</template>

<script>
import CaseDetail from '@/pages/project/case/components/CaseDetail';
export default {
  components: { CaseDetail },
  data() {
    return {
      caseId: parseInt(this.$route.query.caseId) || null,
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  created() {
    if (!this.caseId) {
      this.$router.push({ name: 'page:project:quality:case' });
    }
  }
};
</script>
